module.exports = __webpack_public_path__ + "static/media/East Timor.2df994f2.png";